import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    ButtonsContainer,
    ButtonWrapper,
} from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/topUpProcedureParts/paymentsAdditions/PaymentsAdditions.style';
import { CurrencySymbolType } from 'src_common/common/amount/website-money/currency';
import { Amount } from 'src_common/common/amount/Amount';

interface ButtonAmountPropsType {
    value: string;
    amount: string;
    currency: CurrencySymbolType;
    onChange: (amount: Amount) => void;
    dataTest?: string;
}

const ButtonAmount = observer('ButtonAmount', (props: ButtonAmountPropsType) => {
    const { currency, amount, value, onChange } = props;

    const handleChange = (): void => {
        const convertedAmount = new Amount(value === '' ? '0' : value);
        onChange(convertedAmount.add(new Amount(amount)));
    };

    return (
        <ButtonWrapper
            onClick={handleChange}
            size='small'
            dataTest={`button-amount-${amount}`}
        >
            {currency}
            {amount}
        </ButtonWrapper>
    );
});

interface PropsType {
    value: string;
    options?: Array<string>;
    currency: CurrencySymbolType;
    onChange: (amount: Amount) => void;
}

export const PaymentAdditions = observer('PaymentAdditions', (props: PropsType) => {
    const defOptions = ['10', '20', '50', '100'];
    const { options = defOptions, currency, onChange, value } = props;

    return (
        <ButtonsContainer>
            {options.map((amount) => (
                <ButtonAmount
                    key={amount}
                    value={value}
                    onChange={onChange}
                    amount={amount}
                    currency={currency}
                />
            ))}
        </ButtonsContainer>
    );
});
